import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {searchEndedEvent} from "../models/events/search-ended-event";
import {NEW_SEARCH_WIDGET} from "../../widgets/new-search-widget/new-search-widget.consts";

export class SearchEndedEventHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSearchEnded;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
  }

  async action(params) {
    const clickEvent: searchEndedEvent = new searchEndedEvent(params);

    this.analyticsService.createEvent(clickEvent);
  }
}
